import * as React from "react";
import { Query } from "react-apollo";
import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import gql from "graphql-tag";
import { ArrowDropDown, ArrowDropUp, Remove } from "@material-ui/icons";
import GetAppIcon from '@material-ui/icons/GetApp';
import "./PublisherCategoryStore.scss";
import Rest from "src/services/Rest";
import { QueryFilter } from "src/component/shared";
import ExportInProgress from "src/component/export-in-progress/ExportInProgress";

const PUBLISHER_CATEGORY_STORE_30_DAYS = gql`
  query publisherCategoryStore30Days($customFilter: PublisherCustomFilter) {
    publisherCategoryStore30Days(publisherCustomFilter: $customFilter) {
      loja
      volume
      perc_volume_total
    }
  }
`;

// tslint:disable-next-line:no-empty-interface
interface IPublisherCategoryStoreProps {
  filter: any;
}

// tslint:disable-next-line:no-empty-interface
interface IPublisherCategoryStoreState {
  count: number;
  limit: number;
  offset: number;
  orderBy: string;
  page: number;
  processando: boolean;
}

export class PublisherCategoryStore extends React.Component<
  IPublisherCategoryStoreProps,
  IPublisherCategoryStoreState
> {
  constructor(props: IPublisherCategoryStoreProps) {
    super(props);
    this.state = {
      count: 0,
      limit: 25,
      offset: 0,
      orderBy: "volume",
      page: 0,
      processando: false
    };

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleOrderBy = this.handleOrderBy.bind(this);
  }

  public render() {
    return (
      <Grid container={true} spacing={16}>
        <Grid item={true} xs={12} md={12}>
          <Query
            query={PUBLISHER_CATEGORY_STORE_30_DAYS}
            variables={this.props.filter}
            partialRefetch={true}
          >
            {({ loading, error, data, client }) => {
              return loading ? (
                <LinearProgress />
              ) : (
                <Paper>
                  <Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px'}}>
                <Typography>
                  Informações referentes aos últimos 30 dias
                </Typography>
                {!this.state.processando && 
                  <IconButton
                    color="primary"
                    className="download-button"
                    onClick={() => this.requestExport(client)}
                  >
                    <Tooltip title="Exportar">
                      <GetAppIcon/>
                    </Tooltip>
                  </IconButton>
                }
                <ExportInProgress 
                  tipos={['PUBLISHER_CATEGORIA_LOJA']}
                  visible={this.state.processando}
                  handleState={(valor) => this.setState({processando: valor})}/>
              </div>
                    <CardContent>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Loja</TableCell>
                            <TableCell>
                              Volume
                              <Button
                                className="filter-button"
                                onClick={() => this.handleOrderBy("volume")}
                                title="Clique para filtrar por volume"
                              >
                                {this.state.orderBy === ("volume" || "volumeASC") ? (
                                  this.state.orderBy.includes("ASC") ? (
                                    <ArrowDropDown color="disabled" />
                                  ) : (
                                    <ArrowDropUp color="disabled" />
                                  )
                                ) : (
                                  <Remove color="disabled" />
                                )}
                              </Button>
                            </TableCell>
                            <TableCell>
                              % do volume total
                              <Button
                                className="filter-button"
                                onClick={() =>
                                  this.handleOrderBy("perc_volume_total")
                                }
                                title="Clique para filtrar por % em relacao ao volume total"
                              >
                                {this.state.orderBy.includes("perc_volume_total") ? (
                                  this.state.orderBy.includes("ASC") ? (
                                    <ArrowDropDown color="disabled" />
                                  ) : (
                                    <ArrowDropUp color="disabled" />
                                  )
                                ) : (
                                  <Remove color="disabled" />
                                )}
                              </Button>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {!!data && !!data.publisherCategoryStore30Days ? (
                          <TableBody>
                            {this.paginacaoVirtual(
                              data.publisherCategoryStore30Days
                            ).map((row: any, key: number) => (
                              <TableRow key={key}>
                                <TableCell className="width-50">{row.loja || ""}</TableCell>
                                <TableCell className="width-25">{row.volume || ""}</TableCell>
                                <TableCell className="width-25">{`${row.perc_volume_total}%` || ""}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        ) : (
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                Falha ao aplicar filtro, tente novamente.
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )}
                      </Table>
                      {!!data && !!data.publisherCategoryStore30Days && (
                        <TablePagination
                          className="category-store-pagination"
                          page={this.state.page}
                          count={
                            data.publisherCategoryStore30Days
                              ? data.publisherCategoryStore30Days.length
                              : this.state.count
                          }
                          rowsPerPage={this.state.limit}
                          rowsPerPageOptions={[]}
                          onChangePage={this.handleChangePage}
                          onChangeRowsPerPage={undefined}
                        />
                      )}
                    </CardContent>
                  </Card>
                </Paper>
              );
            }}
          </Query>
        </Grid>
      </Grid>
    );
  }

  private paginacaoVirtual = (data: any[]) => {
    const start = this.state.offset;
    const end = start + this.state.limit;
    const sortBy = this.state.orderBy.replace("ASC", "");
    const sorted = data.sort(
      (a, b) => b[sortBy] - a[sortBy]
    );
    return this.state.orderBy.includes("ASC")
      ? sorted.reverse().slice(start, end)
      : sorted.slice(start, end);
  };

  private handleChangePage(ev: any, newPage: number) {
    if (newPage <= this.state.page) {
      this.setState({
        offset:
          newPage * this.state.limit <= 0 ? 0 : newPage * this.state.limit,
        page: newPage,
      });
    } else {
      this.setState({
        offset: newPage * this.state.limit,
        page: newPage,
      });
    }
  }

  private requestExport = async (client: any) => {
    const endPoint = `publisher-category-store-30days/export`
    const params = QueryFilter.getFilterPublisher(client, this.props.filter, []); 
      const response = await Rest.PostBody(endPoint, params);
      if (response) {
        this.setState({processando: true})
    }
  }

  private handleOrderBy(orderBy: string) {
    if (this.state.orderBy === orderBy) {
      this.state.orderBy.includes("ASC")
        ? this.setState({ orderBy: orderBy.replace("ASC", "") })
        : this.setState({ orderBy: `${orderBy}ASC` });
    } else {
      this.setState({ orderBy });
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/category-store/PublisherCategoryStore.tsx